import { ChartAxisScales } from 'interfaces/chart'
import { rankScale } from 'helpers/trendHelpers'

export const LINEAR_SCALE = 'linear' as const
export const LOG_SCALE = 'log' as const

export const DEFAULT_LINE_CHART_SCALES: ChartAxisScales = {
  x: LINEAR_SCALE,
  y: LINEAR_SCALE,
}

export const RANK_CHART_SCALES: ChartAxisScales = {
  x: LINEAR_SCALE,
  y: rankScale,
}

export const MINIMUM_BAR_WIDTH = .25
